"use client";
import React, { JSX, SVGProps } from "react";
import styles from "./General.module.css";

interface FinalCTAProps {
  title: string;
  description: string;
  ctaText: string;
  bgImage?: string;
  ctaUrl: string;
  onBookDemo?: () => void;
}

function PlayIcon(props: JSX.IntrinsicAttributes & SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="10"
      height="11"
      viewBox="0 0 10 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 3.76795C10.3333 4.53775 10.3333 6.46225 9 7.23205L3.75 10.2631C2.41667 11.0329 0.75 10.0707 0.75 8.53109L0.750001 2.46891C0.750001 0.929308 2.41667 -0.0329403 3.75 0.73686L9 3.76795Z"
        fill="#B0B0B0"
      />
    </svg>
  );
}

const FinalCTA: React.FC<FinalCTAProps> = ({
  title,
  description,
  ctaText,
  bgImage,
  ctaUrl,
  onBookDemo,
}) => (
  <section
    className="relative w-full min-h-[350px] flex items-center justify-center border-t overflow-hidden"
    style={
      bgImage
        ? {
            backgroundImage: `url(${bgImage})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }
        : {}
    }
  >
    <div className="absolute inset-0 bg-black/60 z-0" />
    <div className="relative z-10 max-w-4xl w-full mx-auto flex flex-col md:flex-row items-start justify-start py-20 gap-8 px-4">
      <div className="flex-1 w-full md:w-1/2 flex items-center justify-start mb-6 md:mb-0">
        <h2 className="text-[45px] text-center md:text-4xl font-bold text-white drop-shadow-lg md:text-left w-full">
          {title}
        </h2>
      </div>
      <div className="flex-1 w-full md:w-1/2 flex flex-col items-center md:items-start justify-center">
        <p className="text-lg text-neutral-200 mb-8 drop-shadow-lg text-center md:text-left w-full">
          {description}
        </p>
        <a
          className={`flex items-center gap-2 px-[22px] py-[6px] text-white rounded-full font-medium hover:bg-white transition-colors shadow-lg ${styles.bgGradientBlack}`}
          href={ctaUrl}
        >
          <PlayIcon className="w-6 h-6 mr-2 text-primary" />
          {ctaText}
        </a>
      </div>
    </div>
  </section>
);

export default FinalCTA;
